// media query
export const MOBILE_MAX_WIDTH = 1024;
